import { $api } from "@/shared/api";

// Геометрия карты меняется вместе со справочниками — раз в сутки; за сессию не меняется.
const MAP_STALE_TIME_MS = 60 * 60_000;

// Геометрия карты для тепловой карты матча: лагеря, здания, зиплайны, магазины, миникарта.
// Справочник ещё не загружен — 404 `not_found`.
export const useMapGeometry = () =>
  $api.useQuery("get", "/api/matches/map", undefined, {
    staleTime: MAP_STALE_TIME_MS,
    gcTime: Infinity,
    retry: false,
  });
